import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

export interface QuestionItem {
  Id: number;
  Question_Text: string;
  type_name: string;
  // Add other properties as needed from your Question model
}

@Component({
  selector: "app-select-question",
  templateUrl: "./select-question.component.html",
  styleUrls: ["./select-question.component.scss"]
})
export class SelectQuestionComponent implements OnInit {
  @Input() noneTypeQuestions: QuestionItem[] = [];
  @Input() showModal: boolean = false;

  @Output() modalClosed = new EventEmitter<QuestionItem | null>();

  selectedQuestionId: number | null = null;
  selectedQuestion: QuestionItem | null = null;

  constructor() {}

  ngOnInit(): void {
    // Auto-select first question if only one exists
    if (this.noneTypeQuestions && this.noneTypeQuestions.length === 1) {
      this.selectedQuestionId = this.noneTypeQuestions[0].Id;
      this.selectedQuestion = this.noneTypeQuestions[0];
    }
  }

  /**
   * Select a question as the main question
   */
  selectQuestion(question: QuestionItem): void {
    this.selectedQuestionId = question.Id;
    this.selectedQuestion = question;
  }

  /**
   * Confirm the selected question and emit to parent
   */
  confirmSelection(): void {
    if (this.selectedQuestion) {
      this.modalClosed.emit(this.selectedQuestion);
    }
  }

  /**
   * Close the modal without selection
   */
  closeModal(): void {
    this.modalClosed.emit(null);
  }

  /**
   * Handle backdrop click
   */
  onBackdropClick(): void {
    // Optionally prevent closing on backdrop click
    // this.closeModal();
  }

  /**
   * Reset selection
   */
  resetSelection(): void {
    this.selectedQuestionId = null;
    this.selectedQuestion = null;
  }
}
